import React, { useState, useEffect } from "react";
import { serverUrl } from "../../Utils/server";
import axios from "axios";
import { Route, useHistory } from "react-router";
import ReactLoading from "react-loading";
import { currencySymbol } from "../../Utils/currency";
import FontAwesome from "react-fontawesome";
import ViewOrder from "./ViewOrder";

function Orders() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);

  const monthMapEs = {
    jan: "01",
    ene: "01",
    feb: "02",
    mar: "03",
    apr: "04",
    abr: "04",
    may: "05",
    jun: "06",
    jul: "07",
    aug: "08",
    ago: "08",
    sep: "09",
    oct: "10",
    nov: "11",
    dec: "12",
    dic: "12",
  };

  const formatDateLatam = (value, fallback = "Fecha pendiente") => {
    if (!value) return fallback;

    const raw = String(value).trim();
    if (!raw) return fallback;

    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
    }

    const cleaned = raw
      .split("T")[0]
      .replace(/^(mon|tue|wed|thu|fri|sat|sun|lun|mar|mié|mie|jue|vie|sáb|sab|dom)\s*,\s*/i, "")
      .trim();

    const monthDayMatch = cleaned.match(/^([A-Za-zÁÉÍÓÚáéíóúñÑ]{3})\s+(\d{1,2})(?:,\s*(\d{4}))?$/i);

    if (monthDayMatch) {
      const month = monthMapEs[monthDayMatch[1].toLowerCase()];
      const day = monthDayMatch[2].padStart(2, "0");
      const year = monthDayMatch[3] || String(new Date().getFullYear());

      if (month) {
        return `${day}/${month}/${year}`;
      }
    }

    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) {
      const day = String(parsed.getDate()).padStart(2, "0");
      const month = String(parsed.getMonth() + 1).padStart(2, "0");
      const year = String(parsed.getFullYear());
      return `${day}/${month}/${year}`;
    }

    return raw;
  };

  const statusLabel = (statusValue) => {
    const raw = String(statusValue || "").trim();
    const status = raw.toLowerCase();

    if (!raw) return "Sin estado";
    if (status.includes("cancelled by admin")) return "Cancelado por administrador";
    if (status.includes("order cancelled")) return "Cancelado por cliente";
    if (status.includes("cancelled") || status.includes("cancel")) return "Cancelado";
    if (status.includes("out for delivery")) return "En camino";
    if (status.includes("processing")) return "En preparación";
    if (status.includes("ordered")) return "Pedido realizado";
    if (status.includes("delivered")) return "Entregado";

    return raw;
  };

  const paymentMethodLabel = (paymentMethod) => {
    const raw = String(paymentMethod || "").trim();
    const method = raw.toLowerCase();

    if (!raw) return "No definido";
    if (method === "cash on delivery") return "Pago contra entrega";
    if (method === "online payment") return "Pago en línea";

    return raw;
  };


  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = () => {
    setLoading(true);

    const config = {
      method: "get",
      url: `${serverUrl}/orders/`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
    };

    axios(config).then((response) => {
      setOrders(response.data);
      setLoading(false);
    });
  };

  const getOrdersByQuery = (status) => {
    setLoading(true);

    const config = {
      method: "post",
      url: `${serverUrl}/orders/get-orders-by-query`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
      data: {
        query:
          status === "all"
            ? {}
            : {
                status: status,
              },
      },
    };

    axios(config)
      .then((response) => {
        setOrders(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Route exact path="/orders">
        <div className="content-body">
          <div className="content-title">
            <p>Pedidos</p>
          </div>
          <div className="filter-select">
            <p>Estado del pedido:</p>
            <select
              onChange={(e) => {
                getOrdersByQuery(e.target.value);
              }}
            >
              <option value="all">Todos</option>
              <option value="Ordered">Pedido realizado</option>
              <option value="Processing">En preparación</option>
              <option value="Out for delivery">En camino</option>
              <option value="Order Cancelled">Cancelado por cliente</option>
              <option value="Order Cancelled by Admin">
                Cancelado por administrador
              </option>
              <option value="Delivered">Entregado</option>
            </select>
          </div>
          <div
            style={{
              height: loading ? "70vh" : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {loading ? (
              <ReactLoading
                type={"spinningBubbles"}
                color={"var(--primaryColor)"}
                width={"4rem"}
                height={"4rem"}
              />
            ) : orders.length === 0 ? (
              <p>Sin pedidos</p>
            ) : (
              <table>
                <tr>
                  <th>ID del pedido</th>
                  <th>Fecha</th>
                  <th>Cliente</th>
                  <th>Método de pago</th>
                  <th>Productos</th>
                  <th>Monto</th>
                  <th>Repartidor</th>
                  <th>Estado</th>
                  <th>Detalles</th>
                </tr>
                {orders.map((order, index) => {
                  return (
                    <tr key={index}>
                      <td>{order.orderId}</td>
                      <td>{formatDateLatam(order.date)}</td>
                      <td>{order.clientName}</td>
                      <td>{paymentMethodLabel(order.paymentMethod)}</td>
                      <td>{order.items.length}</td>
                      <td>
                        {currencySymbol}
                        {order.totalPrice}
                      </td>
                      <td>
                        {order.courier && order.courier.name ? (
                          order.courier.name
                        ) : (
                          <i style={{ color: "grey" }}>Sin asignar</i>
                        )}
                      </td>
                      <td>
                        <span
                          className={`orderstatus ${
                            order.status.includes("Cancelled")
                              ? "cancelled "
                              : order.status.includes("Ordered")
                              ? "ordered "
                              : order.status.includes("Processing")
                              ? "processing "
                              : order.status.includes("Out for delivery")
                              ? "out-for-delivery "
                              : order.status.includes("Delivered")
                              ? "delivered "
                              : ""
                          }`}
                        >
                          {statusLabel(order.status)}
                        </span>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            history.push(`/orders/view/${order._id}`);
                          }}
                          style={{
                            background: "white",
                            border: "1px solid var(--primaryColor)",
                          }}
                        >
                          <FontAwesome
                            name="arrow-right"
                            style={{
                              fontSize: "1rem",
                              color: "var(--primaryColor)",
                            }}
                          />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </table>
            )}
          </div>
        </div>
      </Route>
      <Route path="/orders/view/:orderId" component={ViewOrder} />
    </>
  );
}

export default Orders;
